import { render, staticRenderFns } from "./NewsMediaVisor.vue?vue&type=template&id=ecf2392c"
import script from "./NewsMediaVisor.vue?vue&type=script&lang=js"
export * from "./NewsMediaVisor.vue?vue&type=script&lang=js"
import style0 from "./NewsMediaVisor.vue?vue&type=style&index=0&id=ecf2392c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports